import React, { useContext } from "react";
import { NavLink } from "react-router";
import styles from "./mobile-navigation.module.css";
import { House, Sticker } from "lucide-react";
import { MembershipContext } from "hoc/membership-data";
import { useTranslation } from "react-i18next";

const MobileNavigation = () => {
  const { t } = useTranslation();

  const { membership } = useContext(MembershipContext);

  const { first_name, last_name } = membership;

  const isActive = (path) => {
    return window.location.href.includes(path);
  };

  return (
    <div className={styles.container}>
      <NavLink to="/dashboard" className={styles.item}>
        <House
          size={24}
          className={`icon icon-navigation ${
            isActive("/dashboard") ? "icon-navigation-active" : ""
          }`}
        />
        <p className="title-4">{t("navigation.item.dashboard")}</p>
      </NavLink>
      <NavLink to="/teams" className={styles.item}>
        <Sticker
          size={24}
          className={`icon icon-navigation ${
            isActive("/teams") ? "icon-navigation-active" : ""
          }`}
        />
        <p className="title-4">{t("navigation.item.teams")}</p>
      </NavLink>
      <NavLink to="/parameters" className={styles.item}>
        <div className={styles.icon}>
          <p className="title-4">
            {first_name[0]}
            {last_name[0]}
          </p>
        </div>
        <p className="title-4">{t("navigation.item.params")}</p>
      </NavLink>
    </div>
  );
};

export default MobileNavigation;
